import IMAGES_CDN_PATH from '@vend/images-ui'

/**
 * Modify the given image url to be prefixed with the path of the image cdn.
 *
 * @param  input {String}
 *         The url of the image
 *
 * @return {String} The url of the image concatenated with the path of the cdn.
 */
export function imageCdnPath(input) {
  return input && `${IMAGES_CDN_PATH}${input}`
}
